import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.healthcheck.PrimitivesApi';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";


import BigDecimal from "../../../../../server/BigDecimal.js";

class PrimitivesApi extends RpcClass{

    /**
     *  @class PrimitivesApi
     *  @alias module:src/server/com/silkplm/rpc/healthcheck/PrimitivesApi.PrimitivesApi
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     empty() {
            return RpcClass.rpcCall('/rpc/healthcheck/primitives-api/empty', []);
    }
    /** 
     * @async
     * @param i {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     i(i) {
            return RpcClass.rpcCall('/rpc/healthcheck/primitives-api/i', [i]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     lockTest() {
            return RpcClass.rpcCall('/rpc/healthcheck/primitives-api/lock-test', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     longType() {
            return RpcClass.rpcCall('/rpc/healthcheck/primitives-api/long-type', []);
    }
    /** 
     * @async
     * @param toIncrement {Object.<string, number>} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, number>>}
     */
     maps(toIncrement) {
            return RpcClass.rpcCall('/rpc/healthcheck/primitives-api/maps', [toIncrement]);
    }
    /** 
     * @async
     * @param a {BigDecimal} 
     * @param b {BigDecimal} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<BigDecimal>}
     */
     multiply(a, b) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/healthcheck/primitives-api/multiply', [a, b]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new BigDecimal(rawValue)
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param shortP {number} 
     * @param objectShortP {number} 
     * @param longP {number} 
     * @param objectLongP {string} 
     * @param floatP {number} 
     * @param objectFloatP {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     numericTypes(shortP, objectShortP, longP, objectLongP, floatP, objectFloatP) {
            return RpcClass.rpcCall('/rpc/healthcheck/primitives-api/numeric-types', [shortP, objectShortP, longP, objectLongP, floatP, objectFloatP]);
    }
    /** 
     * @async
     * @param toRevert {number[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number[]>}
     */
     revertArray(toRevert) {
            return RpcClass.rpcCall('/rpc/healthcheck/primitives-api/revert-array', [toRevert]);
    }
    /** 
     * @async
     * @param toRevert {string[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string[]>}
     */
     revertList(toRevert) {
            return RpcClass.rpcCall('/rpc/healthcheck/primitives-api/revert-list', [toRevert]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.healthcheck.PrimitivesApi';
metadata.__type_short__ = 'PrimitivesApi';
PrimitivesApi.prototype.__metadata__ = metadata;

PrimitivesApi.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/healthcheck/PrimitivesApi */
export default PrimitivesApi

export { PrimitivesApi }
